import * as _ from 'lodash';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';
import { OutcallCampaignEntity } from '@wephone-core/model/entity/outcallcampaign';

@Component({
  selector: 'app-outcallcampaign-contacts',
  templateUrl: './outcallcampaign-contacts.component.html',
  styleUrls: ['./outcallcampaign-contacts.component.scss']
})
export class OutcallcampaignContactsComponent extends DialogComponentBase implements OnInit {
  dialogTitle = _tk('campaign.tab_campaign_contacts');
  campaign: OutcallCampaignEntity;

  constructor(
    dialogRef: MatDialogRef<OutcallcampaignContactsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    super(dialogRef);
    this.campaign = data.campaign;
  }
}
